import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './PostCredits.icss'

class PostCredits extends Component {
	render() {
		const url = this.props.url
		return (
			<>{this.context.translate('{entityName} from {credit}', {
				entityName: {
					value: this.props.entityName,
					display: value => <strong>{value}</strong>
				},
				credit: {
					value: this.props.credit,
					display: value => (url ? <Link className={styles.link} to={url}>{value}</Link> : <strong>{value}</strong>)
				}
			})}
			</>
		)
	}
}

PostCredits.contextTypes = {
	translate: PropTypes.func
}

PostCredits.propTypes = {
	entityName: PropTypes.string.isRequired,
	credit: PropTypes.string.isRequired,
	url: PropTypes.string
}

PostCredits.defaultProps = {
	url: undefined
}

export default PostCredits



// WEBPACK FOOTER //
// ./src/components/Item/PostCredits.jsx